export default "__VITE_ASSET__P8H1VsVc__"